import { Grid, useEventCallback } from '@mui/material';
import { ForeignForm } from 'shell/view-models/foreign-form';
import { memo } from 'react';
import { PmiTextField } from 'shell/components/shared/text-field';
import ForeignStateList, { ForeignStateVM } from 'shell/components/shared/foreign-state-list';
import { FormikErrors, FormikTouched } from 'formik';
import MunicipalityForeignList, {
  MunicipalityForeignAnprVM,
} from 'shell/components/shared/municipality-foreign-list';
import ParentElement from 'shell/components/shared/parent-element';

interface ForeignComponentProps {
  disabledComponent?: boolean;
  values?: ForeignForm;
  errors?: FormikErrors<ForeignForm>;
  touched?: FormikTouched<ForeignForm>;
  onChange: (key: keyof ForeignForm, value: ForeignForm[keyof ForeignForm]) => void;
  labelState?: string;
  isForeignMunicipalityRequired?: boolean;
  isForeignStateRequired?: boolean;
  labelMunicipality?: string;
}

const ForeignComponent = ({
  disabledComponent,
  values,
  errors,
  onChange,
  isForeignMunicipalityRequired = true,
  isForeignStateRequired = true,
  labelState = 'Stato estero di nascita',
  labelMunicipality = 'Comune estero di nascita',
}: ForeignComponentProps): React.ReactElement => {
  const handleForeignStateListChange = useEventCallback(
    (state: ForeignStateVM | null | undefined) => {
      onChange('state', state);
    }
  );

  const handleInputKeyboardChange = useEventCallback(
    (municipality: MunicipalityForeignAnprVM | null) => {
      onChange('municipality', municipality);
    }
  );

  return (
    <ParentElement disabledComponent={disabledComponent}>
      {disabledComponent && !Boolean(values?.state) ? undefined : (
        <Grid item xs={12} md={disabledComponent ? 3 : 6}>
          <ForeignStateList
            value={values?.state || null}
            onChange={handleForeignStateListChange}
            disabled={disabledComponent}
            label={labelState}
            required={isForeignStateRequired}
            id="foreignStateBirth"
            error={
              //(touched?.state as FormikTouched<ForeignStateVM>) &&
              Boolean(errors?.state as FormikErrors<ForeignStateVM>)
            }
          />
        </Grid>
      )}
      {disabledComponent && !Boolean(values?.municipality) ? undefined : (
        <Grid item xs={12} md={disabledComponent ? 3 : 6}>
          <MunicipalityForeignList
            value={values?.municipality || null}
            onChange={handleInputKeyboardChange}
            label={labelMunicipality}
            required={isForeignMunicipalityRequired}
            id="foreignMunicipality"
            disabled={disabledComponent || !values?.state?.id}
            foreignStateIstatCode={values?.state?.id}
            error={Boolean(errors?.municipality as FormikErrors<MunicipalityForeignAnprVM>)}
          />
        </Grid>
      )}
      {disabledComponent && !Boolean(values?.state?.province) ? undefined : (
        <Grid item xs={12} md={disabledComponent ? 3 : 6}>
          <PmiTextField
            aria-label="Provincia o Contea"
            label="Provincia/Contea"
            id="county"
            name="county"
            fullWidth
            disabled
            type="text"
            variant="outlined"
            value={values?.state?.province || ''}
            onChange={(event) => {
              onChange('province', event.target.value);
            }}
          />
        </Grid>
      )}
    </ParentElement>
  );
};

ForeignComponent.displayName = 'Foreign generality component';

const Foreign = memo(ForeignComponent);

export default Foreign;
